import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { CustomSvgIcon } from 'crazyEditor/components/EditorUI/BaseUI/index';
import * as Colors from 'material-ui/styles/colors';
import IconButton from 'material-ui/IconButton';

export default class CustomSvgIconButton extends Component {
  getBackground() {
    const {
      iconWidth,
      iconHeight,
      iconBackground,
      iconBackgroundWidth,
      iconBackgroundHeight,
      } = this.props;
    const marginLeft = (parseInt(iconBackgroundWidth, 10) - parseInt(iconWidth, 10)) / 2;
    const marginTop = (parseInt(iconBackgroundHeight, 10) - parseInt(iconHeight, 10)) / 2;
    return (<span
      style={{
        borderRadius: '50%',
        position: 'absolute',
        background: iconBackground,
        width: iconBackgroundWidth,
        height: iconBackgroundHeight,
        marginLeft: `-${marginLeft}px`,
        marginTop: `-${marginTop}px`
      }}
    />);
  }

  render() {
    const {
      iconPath,
      iconWidth,
      iconHeight,
      iconStyle,
      iconColor,
      iconProps,
      iconBackground,
      tooltip,
      tooltipPosition,
      onClick,
      disabled,
      } = this.props;
    const disabledOpacity = disabled ? {opacity: 0.7} : null;
    return (
      <IconButton disabled={disabled} tooltip={tooltip} tooltipPosition={tooltipPosition} onClick={onClick}>
        <span>
          {iconBackground && this.getBackground()}
          <CustomSvgIcon path={iconPath}
                         width={iconWidth}
                         height={iconHeight}
                         color={iconColor}
                         {...iconProps}
                         style={_.assign({position: 'relative'}, iconStyle, disabledOpacity)}/>
        </span>
      </IconButton>
    );
  }
}

CustomSvgIconButton.propTypes = {
  iconPath: PropTypes.string.isRequired,
  iconWidth: PropTypes.string.isRequired,
  iconHeight: PropTypes.string.isRequired,
  iconProps: PropTypes.object,
  iconStyle: PropTypes.object,
  iconColor: PropTypes.string,
  iconBackground: PropTypes.string,
  tooltip: PropTypes.string,
  tooltipPosition: PropTypes.string,
  onClick: PropTypes.func
};

CustomSvgIconButton.defaultProps = {
  iconWidth: '24px',
  iconHeight: '24px',
  iconStyle: {},
  iconProps: {},
  iconColor: Colors.grey300,
  tooltipPosition: 'bottom-center',
  iconBackground: null,
  iconBackgroundWidth: '36px',
  iconBackgroundHeight: '36px'
};